import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const toggleCss: CSSObject = {
  maxWidth: "calc(100vw - 32px)",
  padding: "0",
  color: ui.neutral[500],
  outlineOffset: "4px",
};

export const toggleContainerCss: CSSObject = {
  display: "grid",
  "> div": {
    gridColumn: "1/2",
    gridRow: "1/2",
  },
};

export const toggleDisplayContainerCss = (isPressed: boolean) =>
  ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    paddingLeft: "2px",
    height: "1.5rem",
    width: "3rem",
    pointerEvents: "none",

    "> span": {
      zIndex: 0,
      color: ui.white[500],
      fontSize: "0.5rem",
      fontWeight: 700,
      letterSpacing: "1px",
      lineHeight: "10.64px",
      textTransform: "uppercase",
      pointerEvents: "none",
      transition: "color 200ms ease-out",

      "&:last-of-type": {
        color: isPressed ? ui.white[500] : ui.neutral[600],
      },
    },
  }) as CSSObject;
